"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _default = (0, _styledComponents.default)('div').withConfig({
  displayName: "AvatarWrapper",
  componentId: "rdilcg-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;transition-delay:150ms;transition:margin ease 300ms;flex-shrink:0;&:not(:only-of-type),& ~ &:not(:first-of-type){margin-", ":", "px;}&:last-of-type{", "}"], function (props) {
  return props._isListReversed ? 'left' : 'right';
}, function (props) {
  return -1 * props.overlapOffset;
}, function (props) {
  return props._isListReversed && 'margin-left: 0 !important;';
});

exports.default = _default;
module.exports = exports.default;